import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData,
  type UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError,
  type UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse,
  updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut,
} from '../../generated';

export type UpdatePdpMutationVariables = UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData['path'] &
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData['body'];

export type UpdatePdpMutation = UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse;

export const useUpdatePdpMutation = <TError = UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<UpdatePdpMutation, TError, UpdatePdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UpdatePdpMutation, TError, UpdatePdpMutationVariables, TContext>({
    mutationKey: ['UpdatePdp'],
    mutationFn: async ({ portfolio_id, pdp_id, ...body }: UpdatePdpMutationVariables) => {
      const { data } = await updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut({
        path: { portfolio_id, pdp_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUpdatePdpMutation.fetcher = (
  { portfolio_id, pdp_id, ...body }: UpdatePdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut({
      path: { portfolio_id, pdp_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
